import { SOLAR_HOURS } from '../constants/hourly-profile';

const { sunrise, sunset } = SOLAR_HOURS;

/** Solar production fraction at a given hour. Sinusoidal curve sunrise-sunset. */
export function solarFraction(hour: number): number {
	if (hour <= sunrise || hour >= sunset) return 0;
	const x = (hour - sunrise) / (sunset - sunrise);
	return Math.sin(x * Math.PI);
}

/** Cumulative kWh produced up to currentHour (numerical integration). */
export function cumulativeProduction(currentHour: number, dailyMaxKwh: number): number {
	const steps = 120;
	const effectiveHour = Math.min(currentHour, sunset);
	const dt = (effectiveHour - sunrise) / steps;
	if (dt <= 0) return 0;

	let integral = 0;
	for (let i = 0; i < steps; i++) {
		integral += solarFraction(sunrise + i * dt) * dt;
	}

	const fullDayIntegral = (2 / Math.PI) * (sunset - sunrise);
	return Math.round(dailyMaxKwh * (integral / fullDayIntegral) * (Math.PI / (sunset - sunrise)));
}

/**
 * Curva di potenza AC di una giornata tipo, un punto ogni quarto d'ora: non è
 * una misura, è `solarFraction` scalata perché la sua area torni all'energia
 * realmente prodotta quel giorno. Serve dove la telemetria minuto per minuto
 * dell'inverter non esiste più (ring buffer di poche ore) ma il totale
 * giornaliero sì (consolidato permanente) — il "giorno tipo" del monitoraggio
 * impianto sui mesi passati.
 */
export function typicalDayPowerCurve(dailyKwh: number): { ora: string; kw: number }[] {
	const fullDayIntegral = (2 / Math.PI) * (sunset - sunrise);
	const points: { ora: string; kw: number }[] = [];
	for (let h = sunrise; h < sunset; h += 0.25) {
		const kw = dailyKwh > 0 ? (dailyKwh * solarFraction(h)) / fullDayIntegral : 0;
		const hh = String(Math.floor(h)).padStart(2, '0');
		const mm = String(Math.round((h % 1) * 60)).padStart(2, '0');
		points.push({ ora: `${hh}:${mm}`, kw: Math.round(kw * 100) / 100 });
	}
	return points;
}
